import React, { useState, useEffect, useRef } from 'react';

// Polls /version.json (written fresh by every build) and shows a refresh banner
// when a new deploy lands. Kills the "hard-refresh your browser" ticket class.
export default function VersionBanner() {
  const [stale, setStale] = useState(false);
  const baseRef = useRef(null);
  useEffect(() => {
    let alive = true;
    const check = async () => {
      try {
        const r = await fetch('/version.json?ts=' + Date.now(), { cache: 'no-store' });
        if (!r.ok) return;
        const j = await r.json();
        if (!alive || !j.v) return;
        if (baseRef.current === null) baseRef.current = j.v;
        else if (j.v !== baseRef.current) setStale(true);
      } catch (e) { /* offline etc - ignore */ }
    };
    check();
    const t = setInterval(check, 3 * 60 * 1000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  if (!stale) return null;
  return (
    <div onClick={() => window.location.reload(true)}
      style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, cursor: 'pointer',
        background: '#1a4a6b', color: '#fff', textAlign: 'center', padding: '9px 16px',
        fontSize: 13, fontWeight: 600, boxShadow: '0 2px 8px rgba(0,0,0,0.25)' }}>
      TCIO has been updated — tap here to refresh and get the latest version
    </div>
  );
}
